import instance from "./axios";

export const callGetHomeMessage = () => instance.get<string>("api/util/home");